export const ACCESS_USER_TYPE = process.env.REACT_APP_ACCESS_USER_TYPE